module.exports = __webpack_public_path__ + "static/media/dwellPass-logo-white-emblem-400w.c6b130d6.png";